import { useCallback } from 'react'
import { useConnectors, useDisconnect } from 'wagmi'

/**
 * Returns a callback which disconnects from all of the connected connectors
 */
export const useDisconnectConnectors = () => {
	const connectors = useConnectors()
	const { disconnectAsync } = useDisconnect()

	return useCallback(() => Promise.all(connectors.map(connector => disconnectAsync({ connector }))), [connectors])
}
